import { useState } from "react";
import Article from "../Article/Article";
import ImageGrid from "./ImageGrid";
import ImageDetailView from "./ImageDetailView";

export default function MemorialArticle({ data }) {
  const interiorImages = data.interior_images
    //.filter((image) => image.disabled !== true)
    .map((image) => {
      image.type = "interior";
      return image;
    });
  const exteriorImages = data.exterior_images
    // .filter((image) => image.disabled != true)
    .map((image) => {
      image.type = "exterior";
      return image;
    });
  const images = [...interiorImages, ...exteriorImages];
  const [detailViewImage, setDetailViewImage] = useState();

  const handleImageClick = (id) => {
    const image = images.find((image) => image.image.id === id);
    if (image) setDetailViewImage(image);
  };

  const handleDetailNavigation = (step) => {
    const currentIndex = images.findIndex(
      (image) => image.image.id === detailViewImage.image.id,
    );

    let nextImageIndex = (currentIndex + step) % images.length;
    if (nextImageIndex < 0) nextImageIndex = images.length - 1;

    const nextImage = images[nextImageIndex];
    setDetailViewImage(nextImage);
  };

  const handleImageDetailViewClose = () => {
    setDetailViewImage(null);
  };

  return (
    <div className="memorial-article mb-24" id={data.slug} name={data.slug}>
      <Article key={data.slug} data={data.article} header={data.title} />
      <ImageGrid images={interiorImages} onImageClick={handleImageClick} />
      <ImageGrid images={exteriorImages} onImageClick={handleImageClick} />
      {detailViewImage ? (
        <ImageDetailView
          image={detailViewImage.image}
          caption={detailViewImage.caption}
          onNext={() => handleDetailNavigation(1)}
          onPrevious={() => handleDetailNavigation(-1)}
          onClose={handleImageDetailViewClose}
        />
      ) : null}
    </div>
  );
}
